var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHouse = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70833 11.875H7.125V10.2917H8.70833V11.875ZM10.2917 8.70833H5.54167V13.4583H10.2917V8.70833ZM13.4583 4.9875V0.791667H11.0833V2.85L7.91667 0L0 7.125H2.375L7.91667 2.12958L13.4583 7.125H15.8333L13.4583 4.9875Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHouse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/house.b2e0f1a1.svg";
export { ForwardRef as ReactComponent };